<template>

<!--     <div class="toolbar visible-xs hidden-lg hidden-xl hidden-md hidden-sm">
        <div class="row">

            <div class="col-3">
                <a href="" class="btn">
                    <i class="material-icons">event_available</i>
                    <span>Dashboard</span>
                </a>
            </div>          
            <div class="col-3">
                <a href="" class="btn">
                    <i class="material-icons">settings</i>
                    <span>Historico</span>
                </a>
            </div>
            <div class="col-3">
                <a href="" class="btn">
                    <i class="material-icons">account_circle</i>
                    <span>Conta</span>
                </a>
            </div>          
            <div class="col-3">
                <a href="" class="btn">
                    <i class="material-icons">account_circle</i>
                    <span>Conta</span>
                </a>
            </div>         
        </div>
    </div> -->
</template>

<script>
export default {
    name: 'Toolbar',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue